import * as angular from "angular";
import { Effort } from "../../models/effort.model";
import { DialogUtils } from "../../helper/dialog.helper";

let ArchiveEffortDialogComponent = {
    selector: "vcArchiveEffortDialog",
    templateUrl:
        "/angular/components/effort/archive-effort-dialog.component.html",
    bindings: {
        effort: "=",
    },
    controller: class ArchiveEffortDialogController {
        // * bindings for typescript compiler *
        public effort: Effort;
        // ************************************

        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        confirm(effort: Effort): void {
            this.dialog.hide(effort);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("effort", [])
    .component(
        ArchiveEffortDialogComponent.selector,
        ArchiveEffortDialogComponent
    );
